/**
 * Styles WPForms form fields with bootstrap markup.
 * For this to work, go to WPForms > Settings and set "Include Form Styling" to "Base styling only".
 *
 * @see /wp-admin/admin.php?page=wpforms-settings
 * @see https://getbootstrap.com/docs/5.3/forms/overview/
 */
const addBootstrapFormFieldClassesToWpForms = () =>
{
	const wpForms = document.querySelectorAll( '.wpforms-form' );

	wpForms.forEach( wpForm =>
	{
		const controls        = wpForm.querySelectorAll( 'input, select, textarea' );
		const submit          = wpForm.querySelector( '[type="submit"]' );
		const noScriptWarning = wpForm.querySelector( '#wpforms-error-noscript' );

		if (noScriptWarning instanceof HTMLElement) {
			noScriptWarning.style.display = 'none';
		}

		if (submit) {
			submit.classList.add( 'btn', 'btn-primary', 'btn-lg' );
		}

		controls.forEach( control =>
		{
			const label = wpForm.querySelector( 'label[for="' + control.id + '"]' );
			let type    = control.localName;

			if (control instanceof HTMLInputElement) {
				type = control.type;
			}

			switch ( type ) {

				case 'hidden':
				case 'submit':
					break;

				case 'select':
					control.classList.add( 'form-select' );

					if (label) {
						label.classList.add( 'form-label' );
					}

					break;

				case 'radio':
				case 'checkbox':

					const container = control.parentElement;
					const wrapper   = document.createElement( 'div' );

					if (container instanceof HTMLElement) {

						wrapper.classList.add( 'form-check' );
						container.insertAdjacentElement( 'beforebegin', wrapper );
						wrapper.append( control );

						control.classList.add( 'form-check-input' );

						if (label) {
							label.classList.add( 'form-check-label' );
							wrapper.append( label );
						}
					}

					break;

				default:
					control.classList.add( 'form-control' );

					if (label) {
						label.classList.add( 'form-label' );
					}
			}
		} );
	} );
};


/**
 * Wraps WPForm fields in bootstrap column classes.
 *
 * @param {string|number} wpFormId - the id of the WPForm
 * @param {Object<number, string>} columnGridMap - example: {17: 'col col-12'} would add 'col col-12' classes around the field with id 17
 *
 * @see https://getbootstrap.com/docs/5.3/layout/columns/
 */
const addBootstrapColumnsToWpForm = ( wpFormId, columnGridMap ) =>
{
	const fieldWrapper = document.querySelector( `#wpforms-form-${wpFormId} .wpforms-field-container` );

	if (!(fieldWrapper instanceof HTMLElement)) {
		return;
	}

	const fieldContainers = fieldWrapper.querySelectorAll( '.wpforms-field' );

	fieldWrapper.classList.add( 'row' );

	fieldContainers.forEach( fieldContainer =>
	{
		if (fieldContainer instanceof HTMLElement) {

			const fieldIdVal = fieldContainer.dataset.fieldId ?? '';
			const fieldId    = parseInt( fieldIdVal, 10 );
			const wrapper    = document.createElement( 'div' );
			const cssClasses = columnGridMap[fieldId] || 'col col-12';

			if (cssClasses) {
				cssClasses.split( ' ' ).forEach( cssClass => wrapper.classList.add( cssClass ) );
			}

			fieldContainer.insertAdjacentElement( 'beforebegin', wrapper );
			wrapper.appendChild( fieldContainer );
		}
	} );
};


/**
 *
 */
export {addBootstrapFormFieldClassesToWpForms, addBootstrapColumnsToWpForm};
